export default __webpack_public_path__ + "static/media/header.d316e6c5.png";